import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=0c672c7a&lang=pug&"
import script from "./Monitoring.vue?vue&type=script&lang=ts&"
export * from "./Monitoring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports